import { render, staticRenderFns } from "./searchGame.vue?vue&type=template&id=f2e9aba2&scoped=true"
import script from "./searchGame.vue?vue&type=script&lang=js"
export * from "./searchGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e9aba2",
  null
  
)

export default component.exports